<!-- <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" id="themeToggleExpansion">
  <mat-expansion-panel-header>
    <mat-panel-title> Theme Toggle </mat-panel-title>
    <mat-panel-description>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <br />
  <button tabindex='-1' mat-raised-button color="primary" (click)="onSetTheme('dark')">Dark</button>
  <button tabindex='-1' mat-raised-button color="primary" (click)="onSetTheme('light')" style="margin-left: 4px; margin-right: 4px;">Light</button>
  <button tabindex='-1' mat-raised-button color="primary" (click)="onSetTheme('default')">Default</button>
</mat-expansion-panel> -->

<div>
    <button mat-menu-item (click)="$event.stopPropagation();">
      <span style='font-size: 12px;'>
        Dark Mode
        <mat-slide-toggle class="example-margin" (change)="onSetTheme($event)" style='padding-left: 5vw;'>
        </mat-slide-toggle>
      </span>
    </button>
    <!-- <mat-menu #themes="matMenu">
       <div>
          <button mat-menu-item (click)="onSetTheme('dark')">Dark</button>
          <button tabindex='-1' mat-menu-item (click)="onSetTheme('light')">Light</button>
          <button tabindex='-1' mat-menu-item (click)="onSetTheme('default')">Default</button>
       </div>   
    </mat-menu> -->
</div>
